/**
 * Environment-aware logging utility
 * Prevents sensitive information from being logged in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logs a message only in development mode
 * @param {...any} args - Arguments to log
 */
export const log = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Logs an error (always logged, but sanitized in production)
 * @param {string} message - Error message
 * @param {Error} error - Error object (optional)
 */
export const logError = (message, error = null) => {
  if (isDevelopment) {
    console.error(message, error);
  } else {
    // In production, only log the message, not the full error details
    console.error(message);
  }
};

/**
 * Logs a warning only in development mode
 * @param {...any} args - Arguments to log
 */
export const logWarning = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

/**
 * Logs debug information only in development mode
 * @param {...any} args - Arguments to log
 */
export const logDebug = (...args) => {
  if (isDevelopment) {
    console.debug(...args);
  }
};

